var _div;
import { lazy, Suspense } from 'react';
import { useMe } from '@crehana/auth';
import { useAvailableCurrencyByUser, useIsPlayRoomActivated } from '@crehana/compass.playroom';
import { SimpleErrorBoundary } from '@crehana/layouts';
import { jsx as _jsx } from "react/jsx-runtime";
var PlayroomSummaryNotificationButton = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "main-menu-right-menu-desktop-compass-playroom-notification" */'@crehana/compass.playroom').then(function (module) {
    return {
      "default": module.PlayroomSummaryNotificationButton
    };
  });
});
export var GamificationIconButton = function GamificationIconButton() {
  var _me$organization, _me$organization2;
  var _useMe = useMe(),
    me = _useMe.me;
  var organizationSlug = me === null || me === void 0 ? void 0 : (_me$organization = me.organization) === null || _me$organization === void 0 ? void 0 : _me$organization.slug;
  var organizationId = String(me === null || me === void 0 ? void 0 : (_me$organization2 = me.organization) === null || _me$organization2 === void 0 ? void 0 : _me$organization2.originalId);
  var _useIsPlayRoomActivat = useIsPlayRoomActivated(organizationSlug),
    isPlayroomEnabled = _useIsPlayRoomActivat.isActivated,
    isLoadingPlayroomActivated = _useIsPlayRoomActivat.loading;
  var _useAvailableCurrency = useAvailableCurrencyByUser(organizationSlug, undefined, {
      skipQuery: !isPlayroomEnabled || isLoadingPlayroomActivated
    }),
    refetchCrehanaCoins = _useAvailableCurrency.refetch,
    currencyCustomName = _useAvailableCurrency.currencyCustomName,
    crehanaCoinsCurrentUser = _useAvailableCurrency.crehanaCoinsCurrentUser,
    isLoadingCurrencyCoins = _useAvailableCurrency.loading;
  if (isLoadingCurrencyCoins || !isPlayroomEnabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(SimpleErrorBoundary, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: _div || (_div = /*#__PURE__*/_jsx("div", {
        children: "Loading..."
      })),
      children: /*#__PURE__*/_jsx(PlayroomSummaryNotificationButton, {
        organizationId: organizationId,
        organizationSlug: organizationSlug,
        currencyName: currencyCustomName,
        currencyCoins: crehanaCoinsCurrentUser,
        onGoToAchievementsSection: refetchCrehanaCoins
      })
    })
  });
};